// Generated by CoffeeScript 1.6.3




//////////////////
// WEBPACK FOOTER
// ./~/dom-converter/scripts/js/lib/domToMarkup.js
// module id = 2594
// module chunks = 0